/* eslint-disable */
const getters = {
  getPromos(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
